module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'old-browser' && templateVars.config ?
				templateVars.config :
				{
	"isStatic": false,
	"browsers": {
		"Chrome": {
			"version": "30.0"
		},
		"Opera": {
			"version": "40"
		},
		"Firefox": {
			"version": "49"
		},
		"Safari": {
			"version": "9"
		},
		"Microsoft Edge": {
			"version": "14.14393"
		},
		"IE": {
			"version": "9"
		}
	},
	"closable": false
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/old-browser/config.yaml
// module id = 161
// module chunks = 0